
import React, { Component, } from 'react';
import { connect } from 'react-redux'

import {Modal, ModalBody, Button, Card, CardHeader, CardBody, CardFooter} from 'reactstrap';
import CashFloatTypeDialogue from './CashFloatTypeDialogue.js'

var stateManager = require('../../utils/state/stateManager.js');
var navigationDialogueAction = require('../../utils/state/actions/views/navigationDialogue/navigationDialogueAction');
var cashFloatAction = require('../../utils/state/actions/cashFloat/cashFloatAction.js');
var stringUtil = require('../../utils/string/stringUtil.js');
var cashFloatUtil = require('../../utils/domain/cashFloatUtil.js');
var commonUtility = require('../../utils/domain/commonUtility.js');
var staffUtility = require('../../utils/domain/staff/staffUtility.js');
var formatter = require('../../utils/formatter/formatter.js');
var viewUtil = require('../../utils/view/viewUtil.js');
var constants = require('../../utils/domain/constants.js');
var dateUtil = require('../../utils/dateUtil/dateUtil.js');
var logger = require('../../utils/logger/logger.js');
var loggerUtils = require('../../utils/logger/utils.js');
var printUtil = require('../../utils/print/printUtil.js');
var accountsUtil = require('../../utils/domain/accountsUtils');
var notificationChannel = require('../../utils/messaging/notification/notificationChannel');
var jobsServer = require('../../utils/jobs/jobsServer.js');
var guidUtil = require('../../utils/guid/guidUtil.js');
var rmsApiProxyRetry = require('../../utils/api/rmsApiProxyRetry.js');
var translator = require("../../utils/translator/translator");

class CashFloatDialogue extends Component
{
    constructor(props)
    {
        super(props);

        this.renderOutputScreenPanel = this.renderOutputScreenPanel.bind(this);
        this.renderReportingPanel = this.renderReportingPanel.bind(this);
        this.renderSessionJournalReports = this.renderSessionJournalReports.bind(this);
        this.renderKeyPadPanel = this.renderKeyPadPanel.bind(this);

        this.onNumberEntered = this.onNumberEntered.bind(this);
        this.onOpenSession = this.onOpenSession.bind(this);
        this.onCloseSession = this.onCloseSession.bind(this);
        this.onExit = this.onExit.bind(this);
        this.onDeposit = this.onDeposit.bind(this);
        this.onWithdraw = this.onWithdraw.bind(this);
        this.onVoidJournal = this.onVoidJournal.bind(this);
        this.saveSessionIfRequired = this.saveSessionIfRequired.bind(this);

        this.renderTypeDialogue = this.renderTypeDialogue.bind(this);
        this.onPrint = this.onPrint.bind(this);

        this.state = {};
        this.state.isSessionReportLoaded = false;
        this.state.sessionReport = null;
        this.state.todaysOutstandingAmount = 0.0;
        this.state.todaysOutstandingSalesCount = 0;

        this.state.doNeedPublishingFloatSession = false;
        this.state.displayAmount = 0.0;

        this.state.shouldRenderTypeDialogue = false;
        this.state.typeDialogueTitle = null;
    }

    render()
    {
        return(<div>
                    <Modal isOpen={true} centered animation={false} fade={false} size="lg" style={{maxWidth: '90%', width: '90%'}}>
                        <ModalBody>
                            <div style={{height:'80vh'}}>
                                <table height="100%" width="100%">
                                    <tr height="10%">
                                        <td>
                                            {this.renderOutputScreenPanel()}
                                        </td>
                                    </tr>

                                    <tr height="0%">
                                        <td>
                                            <hr style={{margin:'0px'}}/>
                                        </td>
                                    </tr>

                                    <tr>
                                        <table width="100%" height="100%">
                                            <tr>
                                                <td width="55%" height="100%">
                                                    {this.renderReportingPanel()}
                                                </td>
                                                <td height="100%">
                                                    {this.renderKeyPadPanel()}
                                                </td>
                                            </tr>
                                        </table>
                                    </tr>


                                </table>
                            </div>
                        </ModalBody>
                    </Modal>
                    {this.renderTypeDialogue()}
                </div>);
    }

    renderOutputScreenPanel()
    {
        return (
                    <div style={{background:"white", color:"#484848", height:"100%", width:"100%", padding:'5px'}}>
                        <table width="100%" height="100%">
                            <tr>
                                <td>
                                    <div align="right" verticalAlign="middle" style={{color:"#484848", fontSize:'6vh'}}>
                                        {formatter.convertToCurrencyFormat(this.state.displayAmount)}
                                    </div>
                                </td>
                            </tr>
                        </table>    
                    </div>
                )
    }

    renderReportingPanel = ()=>
    {
        return (<div style={{height:'99%', width:'100%', padding:'5px', marginTop:'2px', overflowY:'auto'}}>
                    {this.renderSessionJournalReports()}
                </div>
               );
    }

    renderSessionJournalReports()
    {
        var components = [];

        if (cashFloatUtil.getLoadedFloatSession() == null)
            return (<div className="text-center text-muted">
                        There are no journal entries
                    </div>);

        cashFloatUtil.getLoadedFloatSession().journals.forEach (journal =>
            {
                const givenJournal = journal;
                const disabledVoidButton = cashFloatUtil.isCashFloatSessionClosedOrExpired() || givenJournal.isVoided;
            
                const textDecoration = givenJournal.isVoided ? 'line-through' : null;
                const voidButton = <Button outline color="danger" disabled={disabledVoidButton} onClick={()=>{this.onVoidJournal(givenJournal);}}>{translator.getLabel("void")}</Button>

                var staff = staffUtility.getStaffById(givenJournal.createdByStaffId);
                var staffName = staff != null ? staffUtility.getStaffCompleteName(staff) : 'N/A';
                var footerText = `${translator.getLabel("created_by")} ${staffName}`;

                if (givenJournal.isVoided)
                {
                    staff = staffUtility.getStaffById(givenJournal.voidedBy); 
                    staffName = staff != null ? staffUtility.getStaffCompleteName(staff) : 'N/A';
                    footerText  = `${footerText} | ${translator.getLabel("voided_by")} ${staffName} - ${dateUtil.convertToLocalStandard(givenJournal.voidedDateTime)}`;
                }
                else if (givenJournal.type == constants.floatManagementJournalEntryType.Withdraw && givenJournal.subType == constants.floatManagementJournalEntrySubType.ChangeGiven)
                {
                    staff = staffUtility.getStaffById(givenJournal.subTypeReferenceId); 
                    staffName = staff != null ? staffUtility.getStaffCompleteName(staff) : 'N/A';
                    footerText  = `${footerText} | ${translator.getLabel("change_given_to")} ${staffName}`;
                }
                else if (givenJournal.type == constants.floatManagementJournalEntryType.Withdraw && givenJournal.subType == constants.floatManagementJournalEntrySubType.Expense)
                {
                    const subCategoryId = givenJournal.subTypeReferenceId;
                    let subCategory = accountsUtil.findSubCategory(subCategoryId);

                    footerText = subCategory == null ? `${footerText} | ${translator.getLabel("expense_type")} : N/A` : `${footerText} | ${translator.getLabel("expense_type")} : ${subCategory.name}`;
                }
                else if (givenJournal.type == constants.floatManagementJournalEntryType.Deposit && givenJournal.subType == constants.floatManagementJournalEntrySubType.ChangeReturned)
                {
                    staff = staffUtility.getStaffById(givenJournal.subTypeReferenceId); 
                    staffName = staff != null ? staffUtility.getStaffCompleteName(staff) : 'N/A';
                    footerText = `${footerText} | ${translator.getLabel("change_returned_by")} ${staffName}`;
                }

                components.push(<Card style={{margin:'0px', marginBottom:'2px', padding:'0px'}}>
                                    <CardBody style={{padding:'5px'}}>
                                        <table style={{width:'100%'}}>
                                            <tr>
                                                <td>
                                                    <table style={{width:'100%'}}>
                                                        <tr>
                                                            <td style={{width:'30%', textAlign:'left', verticalAlign:'center', textDecoration:textDecoration}}>
                                                                {dateUtil.convertToLocalStandard(givenJournal.creationDateTime)}
                                                            </td>

                                                            <td style={{width:'20%', textAlign:'left', textDecoration:textDecoration}}>
                                                                {givenJournal.type}
                                                            </td>

                                                            <td style={{width:'20%', textAlign:'left', textDecoration:textDecoration}}>
                                                                {givenJournal.subType}
                                                            </td>

                                                            <td style={{width:'15%', textAlign:'right', textDecoration:textDecoration}}>
                                                                {formatter.convertToCurrencyFormat(givenJournal.amount)}
                                                            </td>

                                                            <td style={{width:'15%', textAlign:'right', textDecoration:textDecoration}}>
                                                                {voidButton}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <hr style={{marginTop:'3px', marginBottom:'3px', padding:'0px'}}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <table style={{width:'100%'}}>
                                                        <tr>
                                                            <td style={{textAlign:'left'}}>
                                                                {footerText}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                        
                                    </CardBody>
                                </Card>);
            });  
        
       
        return (<table width="100%">
                    {components}
                </table>
                )
    }

    renderKeyPadPanel = () =>
    {
        return (
            <table width="100%" height="100%" style={{ borderCollapse: 'separate', borderSpacing: '4px' }} >


                <tr>
                    <td width="33%">
                        <Button color="warning" disabled={cashFloatUtil.isCashFloatSessionClosed()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onCloseSession() }}>{translator.getLabel("close_session")}</Button>
                    </td>
                    <td width="33%">
                        <Button color="success" disabled={!cashFloatUtil.isCashFloatSessionClosed()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onOpenSession() }}>{translator.getLabel("start_session")}</Button>
                    </td>
                    <td width="33%">
                        <Button color="danger" style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onExit() }}>{translator.getLabel("exit")}</Button>
                    </td>
                </tr>

                <tr>
                    <td width="33%">
                        <Button color="secondary" disabled={true} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }}></Button>
                    </td>
                    <td width="33%">
                        <Button color="primary" disabled={cashFloatUtil.isCashFloatSessionClosedOrExpired() || this.state.displayAmount <= 0} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onWithdraw(); }}>Withdraw</Button>
                    </td>
                    <td width="33%">
                        <Button color="primary" disabled={cashFloatUtil.isCashFloatSessionClosedOrExpired() || this.state.displayAmount <= 0} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onDeposit(); }}>Deposit</Button>
                    </td>
                </tr>

                <tr>
                    <td style={{ width: '33%' }}>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(7) }} className='cashing-up-number-button-style'>7</Button>
                    </td>
                    <td style={{ width: '33%' }}>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(8) }} className='cashing-up-number-button-style'>8</Button>
                    </td>
                    <td style={{ width: '33%' }}>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(9) }} className='cashing-up-number-button-style'>9</Button>
                    </td>
                </tr>

                <tr>
                    <td>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(4) }} className='cashing-up-number-button-style'>4</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(5) }} className='cashing-up-number-button-style'>5</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(6) }} className='cashing-up-number-button-style'>6</Button>
                    </td>
                </tr>

                <tr>
                    <td>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(1) }} className='cashing-up-number-button-style'>1</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(2) }} className='cashing-up-number-button-style'>2</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(3) }} className='cashing-up-number-button-style'>3</Button>
                    </td>
                </tr>

                <tr>
                    <td>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontWeight: 'bold', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(-1) }} className='cashing-up-number-button-style'>◄</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(0) }} className='cashing-up-number-button-style'>0</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={cashFloatUtil.isCashFloatSessionExpired()} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(-2) }} className='cashing-up-number-button-style'>00</Button>
                    </td>
                </tr>

            </table>
        )
    }

    onOpenSession()
    {
        viewUtil.showPrompt(translator.getLabel("float_session"), `${translator.getLabel("you_are_about_to_start_a_float_management_session_with_opening_balance_of")} ${formatter.convertToCurrencyFormat(this.state.displayAmount)}`, translator.getLabel("are_you_sure"),
                                        ()=>{
                                                var session = cashFloatUtil.createNewSession();
                                                var journal = cashFloatUtil.createJournal(session.id, constants.floatManagementJournalEntryType.Deposit, constants.floatManagementJournalEntrySubType.OpeningBalance, "", this.state.displayAmount * 1);
                                                session.journals.push(journal);
                                                
                                                this.state.doNeedPublishingFloatSession = true;
                                                stateManager.getStore().dispatch(cashFloatAction.createAction(session));
                                                
                                                printUtil.openCashDrawer();
                                                viewUtil.showSuccessAlert(translator.getLabel("float_session_opened_successfully"));
                                                this.onExit();                                                
                                            });
    }

    onCloseSession()
    {
        viewUtil.showPrompt(translator.getLabel("float_session"), translator.getLabel("you_are_about_to_close_a_float_management_session"), translator.getLabel("are_you_sure"),
                                        ()=>{
                                                var session = cashFloatUtil.getLoadedFloatSession();
                                                cashFloatUtil.closeSession(session);
                                                this.onPrint();
                                                
                                                this.state.doNeedPublishingFloatSession = true;
                                                stateManager.getStore().dispatch(cashFloatAction.createAction(session));

                                                printUtil.openCashDrawer();
                                                viewUtil.showSuccessAlert(translator.getLabel("float_session_closed_successfully"));
                                                this.onExit();
                                            });
    }

    onExit()
    {
        this.saveSessionIfRequired();
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
    }

    onDeposit()
    {
        this.state.typeDialogueTypes = []

        var type = {};
        type.id = constants.floatManagementJournalEntrySubType.TransferFromSafe;
        type.description = translator.getLabel("transfer_from_safe");
        type.cloudType = "app"
        type.SubTypes = [];
        type.subTypeRequired = false;
        this.state.typeDialogueTypes.push(type);

        var type = {};
        type.id = constants.floatManagementJournalEntrySubType.ChangeReturned;
        type.description = translator.getLabel("change_returned");
        type.cloudType = "app"
        type.SubTypes = [];
        type.subTypeRequired = true;
        staffUtility.getAllActiveStaff().forEach (staff =>
            {
                var staffType = {};
                staffType.id = staff.id;
                staff.description = `${staff.firstName} ${staff.lastName}`;
                if (!stringUtil.isStringNullOrEmpty(staff.pictUrl))
                {
                    staff.cloudType = "users"
                }
                else
                {
                    staff.cloudType = "app"
                }
                type.SubTypes.push(staff);
            })
        this.state.typeDialogueTypes.push(type);

        this.state.shouldRenderTypeDialogue = true;
        this.state.typeDialogueTitle = translator.getLabel("please_choose_reason_of_deposit");
        this.state.typeDialogueCallBack = (type, subType) =>
                                            {
                                                var session = cashFloatUtil.getLoadedFloatSession();
                                                var journal = cashFloatUtil.createJournal(session.id, constants.floatManagementJournalEntryType.Deposit, type, subType, this.state.displayAmount * 1);
                                                session.journals.push(journal);
                                                printUtil.openCashDrawer();
                                            };
        this.setState({});
    }

    onWithdraw()
    {
        this.state.typeDialogueTypes = []

        var type = {};

        if(commonUtility.isModuleSubscribed("Accounts"))
        {
            type.id = constants.floatManagementJournalEntrySubType.Expense;
            type.description = translator.getLabel("expense");
            type.cloudType = "app"
            type.SubTypes = [];
            type.subTypeRequired = true;
            cashFloatUtil.getExpenseSubCategoriesOfFloatSession().forEach(subCategory =>
                {
                    var expenseSubCategoryType = {};
                    expenseSubCategoryType.id = subCategory.id;
                    expenseSubCategoryType.description = subCategory.name;
                    type.SubTypes.push(expenseSubCategoryType);
                });
            this.state.typeDialogueTypes.push(type);
        }

        var type = {};
        type.id = constants.floatManagementJournalEntrySubType.TransferToSafe;
        type.description = translator.getLabel("transfer_to_safe");
        type.cloudType = "app"
        type.SubTypes = [];
        type.subTypeRequired = false;
        this.state.typeDialogueTypes.push(type);

        var type = {};
        type.id = constants.floatManagementJournalEntrySubType.ChangeGiven
        type.description = translator.getLabel("change_given");
        type.cloudType = "app"
        type.SubTypes = [];
        type.subTypeRequired = true;
        staffUtility.getAllActiveStaff().forEach (staff =>
            {
                var staffType = {};
                staffType.id = staff.id;
                staff.description = `${staff.firstName} ${staff.lastName}`;
                if (!stringUtil.isStringNullOrEmpty(staff.pictUrl))
                {
                    staff.cloudType = "users"
                }
                else
                {
                    staff.cloudType = "app"
                }
                type.SubTypes.push(staff);
            })
        this.state.typeDialogueTypes.push(type);
        
        this.state.shouldRenderTypeDialogue = true;
        this.state.typeDialogueTitle = translator.getLabel("please_choose_reason_of_withdraw");
        this.state.typeDialogueCallBack = (type, subType) =>
                                            {
                                                var session = cashFloatUtil.getLoadedFloatSession();
                                                var journal = cashFloatUtil.createJournal(session.id, constants.floatManagementJournalEntryType.Withdraw, type, subType, this.state.displayAmount * 1);
                                                session.journals.push(journal);
                                                printUtil.openCashDrawer();
                                            };
        this.setState({});
    }

    onVoidJournal(journal)
    {
        viewUtil.showPrompt(translator.getLabel("float_session"), `${translator.getLabel("you_are_about_to_void_a_journal_entry_with_amount")} ${formatter.convertToCurrencyFormat(journal.amount)}`, translator.getLabel("are_you_sure"),
                                        ()=>{
                                                cashFloatUtil.voidJournal(journal);
                                                this.state.doNeedPublishingFloatSession = true;
                                                this.setState({});
                                            },);
    }

    saveSessionIfRequired()
    {
        if (!this.state.doNeedPublishingFloatSession)
            return;
        
        this.publishFloatSessionInChannel();

        jobsServer.addJob(guidUtil.generateGuid(), "FloatSession.Save", 
                        async ()=>
                        {
                            logger.info("Calling API to persist float session");
                            var resourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/floats`;
                            await rmsApiProxyRetry.post(resourceUrl, cashFloatUtil.getLoadedFloatSession());
                            logger.info("Successfully persisted float session");
                            return true;
                        })
    }

    publishFloatSessionInChannel()
    {
        var orgContext = {
            franchisorId: commonUtility.getFranchisor().id,
            franchiseeId: commonUtility.getFranchisee().id,
            propertyId: commonUtility.getProperty().id
         }

        var messagePayload = {};
        messagePayload.type = "float.session";
        messagePayload.notificationType = "float.session";
        messagePayload.session = cashFloatUtil.getLoadedFloatSession();
        messagePayload.orgContext = orgContext;
        messagePayload.tracingContext = loggerUtils.createTracingContext("notifications.channel", messagePayload.notificationType);

        logger.info("Publishing a message to notification channel for float session");
        notificationChannel.publishMessage(messagePayload);
    }

    onNumberEntered = (number) =>
    {
        if (number >= 0)
        {
            this.state.displayAmount = formatter.roundUp(this.state.displayAmount * 10 + number / 100, 2);
        }

        if (number == -1)
        {
            this.state.displayAmount = formatter.roundUp(Math.round(100 * this.state.displayAmount/10) / 100, 2);
        }

        if (number == -2)
        {
            this.state.displayAmount = formatter.roundUp(this.state.displayAmount * 100, 2);
        }


        this.setState({});
    }

    renderTypeDialogue()
    {
        if (!this.state.shouldRenderTypeDialogue)
            return;

        return (<CashFloatTypeDialogue title={this.state.typeDialogueTitle} types={this.state.typeDialogueTypes} onClose={(okFlag, type, subType)=>
                                                                                         {
                                                                                            if (okFlag)
                                                                                            {
                                                                                                this.state.typeDialogueCallBack(type.id, subType == null ? null : subType.id);
                                                                                                this.state.doNeedPublishingFloatSession = true;
                                                                                                this.state.displayAmount = 0.0;
                                                                                            }
                                                                                            this.state.typeDialogueTypes = [];
                                                                                            this.state.typeDialogueCallBack = null;
                                                                                            this.state.shouldRenderTypeDialogue = false;
                                                                                            this.state.typeDialogueTitle = "";
                                                                                            this.setState({});
                                                                                          }}>
                                                                                            
                </CashFloatTypeDialogue>)
    }

    onPrint()
    {   
    }
    

}

const mapStateToProps = state => 
{
    return { 
              cashFloatPayload: cashFloatUtil.getLoadedFloatSession()
          }
}

export default connect(mapStateToProps)(CashFloatDialogue)

